import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["templateId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { API_SERVICE_NAMES } from 'src/constants/apiServiceName';
import { requestService } from 'src/core/services/api';
import { chargeExportTemplateRoutes } from './routes';

/** The saved column mappings the bulk charge export runs with. */
export class ChargeExportTemplates {
  constructor() {
    _defineProperty(this, "routes", chargeExportTemplateRoutes);
  }
  /** The catalogue of mappable Livable fields. Served rather than hardcoded so the picker cannot drift from the export. */
  async getFields(options) {
    const resp = await requestService(API_SERVICE_NAMES.PAYMENT).get(this.routes.fields, _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  /** Templates usable for a property: the ones scoped to it plus the account-level ones. */
  async getTemplates(data, options) {
    const query = data.propertyId ? "?propertyId=".concat(data.propertyId) : '';
    const resp = await requestService(API_SERVICE_NAMES.PAYMENT).get("".concat(this.routes.list).concat(query), _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  /** Creates a template, or replaces one outright when `templateId` is set. */
  async saveTemplate(data, options) {
    const templateId = data.templateId,
      body = _objectWithoutProperties(data, _excluded);
    const service = requestService(API_SERVICE_NAMES.PAYMENT);
    const resp = templateId ? await service.put(this.routes.byId(templateId), body, _objectSpread({}, options.cancelToken)) : await service.post(this.routes.list, body, _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  /** Makes a template the default of its own scope. */
  async setDefaultTemplate(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.PAYMENT).post(this.routes.setDefault(data.templateId), {}, _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  /** Soft-deletes a template. */
  async deleteTemplate(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.PAYMENT).delete(this.routes.byId(data.templateId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}